import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Container, FormControl, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Typography } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { CboEspecialidades } from "../../cbos/CboEspecialidades";
import { useForm } from "../../../hooks/useForm";
import { fetchLocalidades } from "../../../actions/cbos/localidades";
import { fetchProvincias } from "../../../actions/cbos/provincias";
import { getRubrosEfector } from "../../../actions/contrataciones/contratacionesCartilla";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getCartillaMiOspedyc, getMiCartillaMiOspedyc } from "../../../actions/webAfiliado/cartillaMiOspedycActions";
import { ItemCartilla } from "./ItemCartilla";
import LoadingBeforeViewData from "../../compartidos/LoadingBeforeViewData";
import BarCartilla from "./BarCartilla";

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        marginTop: "1rem",
        marginBottom: "3rem"
    },
    textRadios: {
        fontWeight: "bold",
        textTransform: 'capitalize'
    },
    title: {
        fontWeight: "bold",
    },
    containerItemsCatilla: {
        marginTop: "2.5rem"
    },
}));

export const Cartilla = () => {

    const classes = useStyles();
    const dispatch = useDispatch()

    const { items: provincias } = useSelector(state => state.provincias);
    const { items: localidades } = useSelector(state => state.localidades);
    const { rubros } = useSelector((state) => state.contratacionesCartilla);
    const { datosCartilla, miCartilla } = useSelector((state) => state.cartillaMiOspedyc);

    const initialValues = {
        idRubro: "",
        idLocalidad: "",
        idProvincia: "",
        idEspecialidad: ""
    }

    const [
        formValues,
        handleInputChange,
        ,
        setearValor
    ] = useForm(initialValues);

    const {
        idRubro,
        idLocalidad,
        idProvincia,
        idEspecialidad
    } = formValues;

    const handleSubmit = (e) => {
        e.preventDefault()
        dispatch(getCartillaMiOspedyc(idEspecialidad, idProvincia, idLocalidad, idRubro))
    }

    useEffect(() => {
        dispatch(fetchProvincias())
        dispatch(fetchLocalidades())
        dispatch(getRubrosEfector())
        dispatch(getMiCartillaMiOspedyc())
        // eslint-disable-next-line
    }, [])

    if (miCartilla === null)
        return <LoadingBeforeViewData />

    return (
        <div className={classes.root}>
            <Typography align="center" variant="h4" color="primary" className={classes.title}>Cartilla</Typography>
            <BarCartilla />
            <Container maxWidth="lg">
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                >
                    <Grid item xs={12}>
                        <ValidatorForm onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <FormControl component="fieldset" fullWidth>
                                        <RadioGroup aria-label="rubro" name="idRubro" value={idRubro.toString()} onChange={handleInputChange} defaultValue="top" row style={{ justifyContent: "center" }}>
                                            {rubros.map(item => <FormControlLabel key={item.idRubro} value={item.idRubro.toString()} control={<Radio />} label={<Typography variant="body2" color="textSecondary" className={classes.textRadios}>{item.descripcion.toLowerCase()}</Typography>} />)}
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <CboEspecialidades
                                        manejadorInputChange={handleInputChange}
                                        valor={idEspecialidad}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <SelectValidator
                                        fullWidth
                                        margin="normal"
                                        label="Provincias"
                                        name="idProvincia"
                                        value={idProvincia}
                                        onChange={handleInputChange}
                                        validators={['required']}
                                        errorMessages={['Selecione una opción']}
                                    >
                                        <MenuItem value=""><em>Seleccione...</em></MenuItem>
                                        {provincias.map((item) => <MenuItem key={item.id_provincia} value={item.id_provincia}>{item.descripcion_provincia}</MenuItem>)}
                                    </SelectValidator>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Autocomplete
                                        fullWidth
                                        options={localidades.filter(x => x.id_provincia === idProvincia)}
                                        value={localidades.filter(x => x.id_provincia === idProvincia).find(e => e.id_localidad === idLocalidad) || null}
                                        onChange={(e, selected) => {
                                            setearValor("idLocalidad", selected?.id_localidad || "")
                                        }}
                                        getOptionLabel={(option) => option.descripcion_localidad}
                                        renderInput={
                                            (params) =>
                                                <TextValidator
                                                    {...params}
                                                    label="Localidades"
                                                    margin="normal"
                                                />
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container justify="flex-end">
                                        <Grid item><Button type="submit" variant='outlined' color="primary" >CONSULTAR</Button></Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Grid>
                    {
                        datosCartilla &&
                        <Grid item xs={12} className={classes.containerItemsCatilla} >
                            <Container>
                                <Grid container spacing={5}>
                                    {
                                        datosCartilla.length === 0 &&
                                        <Grid item xs={12}><Typography color="secondary" variant="subtitle1" align="center" style={{ fontWeight: "bold" }}>No hay datos de cartilla para mostrar</Typography></Grid>
                                    }
                                    {
                                        datosCartilla.map((item, index) =>
                                            <Grid key={index} item xs={12} sm={6}>
                                                <ItemCartilla item={item} />
                                            </Grid>
                                        )
                                    }
                                </Grid>
                            </Container>
                        </Grid>
                    }
                </Grid>
            </Container>
        </div>
    );
};
